import { FC, useState } from "react";
import { ColorPickerPopup } from "shared/ui";
import type { OsMASettings } from "../../model";
import styles from "./ADXStylesTab.module.css";

interface Props {
  settings: OsMASettings;
  onChange: (s: OsMASettings) => void;
}

export const OsMAStylesTab: FC<Props> = ({ settings, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.tab}>
      <div className={styles.row}>
        <div className={styles.left}>
          <label className={styles.checkboxWrap}>
            <input
              type="checkbox"
              className={styles.checkboxInput}
              checked={settings.histogramVisible}
              onChange={(e) => onChange({ ...settings, histogramVisible: e.target.checked })}
            />
            <span className={styles.checkmark} />
          </label>
          <span className={styles.label}>histogram</span>
        </div>
        <div className={styles.btnWrap}>
          <button
            className={styles.colorBtn}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span className={styles.colorBtnSwatch} style={{ background: settings.histogramColor }} />
          </button>
          {open && (
            <ColorPickerPopup
              color={settings.histogramColor}
              onChange={(c) => onChange({ ...settings, histogramColor: c })}
              onClose={() => setOpen(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
